import * as React from 'react';
import { Table, CustomButton, ButtonType } from "soprasteria-ui-library";
import { IRiskPotReportPreAssessment } from '../../../models/IRiskPotReport';
import { dateTimeToDateString } from '../../../helpers/DateHelper';
import { isInRole, UserContext } from '../../../contexts/UserContext';
import { ALLMÄNTANDVÅRDBAS } from '../../../utils/RoleConstants';

interface IPreAssessmentsTable {
    preAssessments: IRiskPotReportPreAssessment[];
    getPreAssessment: (preAssessmentId: number) => void;
    canCreatePreAssessment: boolean;
    setRenderForm: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PreAssessmentsTable: React.FunctionComponent<IPreAssessmentsTable> = ({ preAssessments, getPreAssessment, canCreatePreAssessment, setRenderForm }) => {

    const userInfo = React.useContext(UserContext);
    const hasRoleAllmanTandvard = isInRole(ALLMÄNTANDVÅRDBAS, userInfo.roles);

    const renderClickableColumn = (text: string, preAssessmentId: number) => {
        return <td onClick={() => getPreAssessment(preAssessmentId)}>{text}</td>
    }

    const getPreAssessmentStatusLabel = (statusText: string, hasUnreadDecision: boolean): string => {
        if (hasRoleAllmanTandvard && hasUnreadDecision) {
            return `${statusText} (oläst)`;
        }

        return statusText;
    }

    return (
        canCreatePreAssessment || preAssessments.length > 0 ?
            <>
                <hr />
                <div className="row panel">
                    <div className="col-6 text-left">
                        <h5>Förhandsbedömningar</h5>
                    </div>
                    <div className="col-6 text-right">
                        {hasRoleAllmanTandvard ?

                            canCreatePreAssessment
                                ? <CustomButton buttonType={ButtonType.create} buttonText="Skapa begäran om förhandsbedömning" data-toggle="modal" data-target="#create-pre-assessment-modal" id="open-create-pre-assessment-modal" onClick={() => setRenderForm(true)} />
                                : <CustomButton buttonType={ButtonType.create} disabled buttonText="Skapa begäran om förhandsbedömning"
                                    title={"Det går inte att skapa en förhandsbedömning."} />
                            : null
                        }
                        <span className="d-none">
                            <CustomButton buttonType={ButtonType.create} buttonText="Skapa begäran om förhandsbedömning" data-toggle="modal" data-target="#create-pre-assessment-modal" id="open-create-pre-assessment-modal" onClick={() => setRenderForm(true)} />
                        </span>
                    </div>
                </div>
                <Table hoverableRows>
                    <thead>
                        <tr>
                            <th>Ärendestatus</th>
                            <th>Skickad</th>
                            <th>Beslutsdatum</th>                            
                        </tr>
                    </thead>
                    <tbody>
                        {
                            preAssessments.length > 0 ?
                                preAssessments.map((preAssessment, key) =>
                                    <tr key={key} className="clickable-row">
                                        {renderClickableColumn(getPreAssessmentStatusLabel(preAssessment.status, preAssessment.hasUnreadDecision), preAssessment.preAssessmentId)}
                                        {renderClickableColumn(dateTimeToDateString(preAssessment.sentDate), preAssessment.preAssessmentId)}
                                        {renderClickableColumn(dateTimeToDateString(preAssessment.decisionDate), preAssessment.preAssessmentId)}                                        
                                    </tr>
                                )
                                :
                                <tr><td colSpan={3}>Det finns inga begärda förhandsbedömningar</td></tr>
                        }
                    </tbody>
                </Table>
            </>
            : null
    )
}